import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  dark_mode: "light",
  snackbar: {
    open: false,
    message: "",
    severity: "info",
  },
  anchorElUser : null,
};

export const common = createSlice({
  name: "common",
  initialState,
  reducers: {
    set_dark_mode: (state, action) => {
      state.dark_mode = action.payload
        ? action.payload
        : state.dark_mode === "light"
        ? "dark"
        : "light";
    },
    setSnackBar: (state, action) => {
      state.snackbar = action.payload;
    },
    setAnchorElUser : (state,action) => {
      state.anchorElUser = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  set_dark_mode,
  setSnackBar,
  setAnchorElUser,
} = common.actions;

export default common.reducer;